<template>
    <el-dialog title="资源购买" :visible.sync="dialogVisible" class="dialogClass"  width="360px">
        <div class="content">
            <!-- 行与行之间有水平线 -->
            <div class="row" style="border-bottom: 1px solid #f5f6f7;">
                <span class="title-score">资源所需积分</span>
                <span class="score">{{articleInfo.articleScore}}</span>
                <span class="amount-text">（{{(articleInfo.articleScore/10).toFixed(1)}}元）</span>
            </div>
            <div class="row">
                <span class="title-score">当前拥有积分</span>
                <span class="score">{{articleInfo.userScore}}</span>
            </div>
            <div class="row">
                <span class="title-score">我的账户余额</span>
                <span class="score">{{articleInfo.amounts}}</span>
                <span class="amount-text">（{{articleInfo.amounts * 10}}积分）</span>
                <span class="score-tip">
                    <el-tooltip class="item" effect="dark" content="1积分等于0.1￥" placement="top">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </span>
            </div>
        </div>
        <template #footer>
            <div v-if="!promptComment" class="footer-left">
                <div v-if="lackScore <= 0" class="score-info">
                    <span>消耗：</span>
                    <span class="score">{{totalConsumption}}</span>
                    <span class="score-tip">
                        <el-tooltip v-if="articleInfo.userScore >= articleInfo.articleScore" class="item" effect="dark" :content="'账户积分(' + articleInfo.articleScore + ') - 余额(0)'" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                        <el-tooltip v-if="articleInfo.userScore < articleInfo.articleScore" class="item" effect="dark" :content="'账户积分(' + articleInfo.userScore + ') + 账户金额('+ (articleInfo.articleScore - articleInfo.userScore) +')'" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </span>
                </div>
                <div v-if="lackScore > 0" class="score-info">
                    <span>缺少：</span>
                    <span class="score">{{lackScore}}</span>
                    <span class="score-tip">
                        <el-tooltip class="item" effect="dark" :content="'文章积分(' + articleInfo.articleScore + ') - 账户积分(' + articleInfo.userScore + ') - 余额(' + articleInfo.amounts + ')'" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </span>
                </div>
            </div>
            <span v-if="promptComment">{{promptComment}}</span>
            <span v-if="!isPay" class="dialog-footer">
                <el-button type="success" style="color: #f8e3c3 !important;background-color:#696a77;" @click="handleConfirm" class="custom-button">立即购买</el-button>
            </span>
            <span v-if="isPay" class="dialog-footer">
                <el-button type="success" style="color: #f8e3c3 !important;background-color:#696a77;" @click="handleRecharge" class="custom-button">去充值</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
    import {articleScoreInfo, articleAttachmentPay} from '@/api'
    export default {
        name: 'AttachmentWindow',
        props: {
            articleId: {
                type: Number
            },
        },
        data() {
            return {
                dialogVisible: false,
                articleInfo: {
                    articleScore: 0,
                    userScore: 0,
                    totalScore: 0
                },
                isPay: false,
                totalConsumption: 0,
                promptComment: null,
                lackScore: 0
            };
        },
        created() {
            this.articleScoreInfo()
        },
        methods: {
            resetState() {
                this.articleInfo = {
                    articleScore: 0,
                    userScore: 0,
                    totalScore: 0
                };
                this.isPay = false;
                this.totalConsumption = 0;
                this.promptComment = null;
                this.lackScore = 0;
            },
            handleConfirm() {
                //获取文章作者信息
                articleAttachmentPay({
                    articleId: this.articleId
                }).then(res => {
                    if (res.data != null){
                        this.$toast.success('兑换成功')
                        // 发射事件通知父组件刷新数据
                        this.$emit('refresh-data')
                        for (let i = 0; i < res.data.length; i++){
                            let fileUrl = res.data[i].downloadUrl; // 替换为实际的文件URL
                            if (fileUrl != null){
                                const link = document.createElement('a');
                                link.href = encodeURI(fileUrl); // 对URL进行编码
                                link.download = res.data[i].fileName; // 设置下载的文件名
                                // 将 <a> 元素添加到 DOM 中
                                document.body.appendChild(link);

                                // 模拟点击以触发下载
                                link.click();
                                // 下载完成后移除 <a> 元素
                                document.body.removeChild(link);
                            }
                        }
                    }
                })
            },
            handleRecharge() {
                this.dialogVisible = false;
                this.$router.push('/user/single/recharge');
            },
            articleScoreInfo(){
                //获取文章作者信息
                articleScoreInfo(this.articleId).then(res => {
                    if (res.data != null){
                        this.articleInfo = res.data
                        this.dialogVisible = true
                        if (res.data.isPay > 0){
                            this.promptComment = "您已经兑换，不会扣除您的积分。"
                        }else{
                            this.lackScore = res.data.articleScore - res.data.amounts * 10 - res.data.userScore;
                            if (res.data.userScore < res.data.articleScore){
                                if (res.data.amounts > 0){
                                    if (res.data.amounts * 10 + res.data.userScore >= res.data.articleScore){
                                        this.isPay = false
                                    }else{
                                        this.isPay = true
                                    }
                                }else{
                                    this.isPay = true
                                }
                            }
                            this.totalConsumption = res.data.articleScore;
                        }
                    }else{
                        this.dialogVisible = false
                    }
                })
            }
        }
    };
</script>

<style scoped>
    .content {
        width: 100%; /* 确保父容器有足够的宽度 */
        border: 1px solid #f5f6f7;
        border-radius: 2px;
        font-size: 14px;
    }
    .row {
        display: flex;
        justify-content: space-between; /* 子元素之间自动分配空间 */
        align-items: center; /* 垂直居中对齐 */
        /*margin-bottom: 10px; !* 调整行间距 *!*/
        padding: 5px 10px; /* 可选：调整上下内边距 */
        line-height: 1.5;
    }
    .title-score {
        flex-grow: 1; /* 让标题占满剩余空间 */
    }
    .score {
        margin-left: auto; /* 将分数推到最右边 */
        color: #b87100 !important;
    }
    .dialogClass .el-dialog__body {
        padding: 0 !important; /* 确保覆盖默认样式 */
    }
    .dialogClass ::v-deep .el-dialog__body {
        padding: 15px !important;
    }
    .dialogClass ::v-deep .el-dialog__footer {
        padding: 10px 15px!important;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        color: #909399;
        line-height: 26px;
    }
    .dialogClass .el-button{
        border-radius: 50px;
        padding: 8px 20px;
        border-color: #fdf2e2;
    }
    .footer-left {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
    .score-info {
        display: flex;
        align-items: center;
        gap: 4px;
    }
    .score-info .score {
        color: #b87100 !important;
    }
    .score-tip {
        margin-left: 5px;
        color: #909399;
        cursor: pointer;
    }
</style>
